import React from 'react';

import './team-members.styles.scss';

/* eslint-disable-next-line */
export interface TeamMembersProps {}

const teamMembers = [
  {
    photoUrl: require('../../../assets/photos/team/erich.png'),
    name: 'Erich Ko',
    position: 'Co-Founder and CEO',
    socials: [
      { name: 'linkedin', link: 'https://www.linkedin.com/in/erich-ko/' },
    ],
  },
  {
    photoUrl: require('../../../assets/photos/team/boyd.png'),
    name: 'Boyd Reid',
    position: 'Co-Founder and COO',
    socials: [
      {
        name: 'linkedin',
        link: 'https://www.linkedin.com/in/boyd-reid-319b88ab/',
      },
    ],
  },
  {
    photoUrl: require('../../../assets/photos/team/erwin.png'),
    name: 'Erwin Komguem',
    position: 'Co-Founder and CTO',
    socials: [
      {
        name: 'linkedin',
        link: 'https://www.linkedin.com/in/erwin-jeffrey-komguem/',
      },
    ],
  },
];

export function TeamMembers(props: TeamMembersProps) {
  return (
    <div className="scientist bg-color pb-70">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">Team Members</span>
          <h2>Our Founding Team</h2>
        </div>

        <div className="row">
          {teamMembers.map(({ name, photoUrl, position, socials }, i) => (
            <div className="col-lg-4 col-sm-6 col-md-6" key={i}>
              <div className="single-scientist-box">
                <div className="image">
                  <img src={photoUrl} alt="about" />
                </div>
                <div className="content">
                  <h3>{name}</h3>
                  <span>{position}</span>

                  <ul className="social">
                    {socials.map(({ name, link }, i) => (
                      <li key={i}>
                        <a
                          href={link}
                          className="d-block"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className={`bx bxl-${name}`}></i>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TeamMembers;
